import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MyprofileRoutingModule } from '../myprofile/myprofile-routing.module';
import { OwlDateTimeModule } from 'ng-pick-datetime';
import { SharedModule } from 'app/shared/shared.module';
import { ReactiveFormsModule } from '@angular/forms';
import { VoucherComponent } from './voucher.component';
import { VoucherRoutingModule } from './voucher-routing.module';
import { MatSelectModule } from '@angular/material';

@NgModule({
  declarations: [VoucherComponent],
  imports: [
    NgbModule,    
    CommonModule,   
    SharedModule,
    MatSelectModule,
    VoucherRoutingModule,
    ReactiveFormsModule
  ]
})
export class VoucherModule { }
